<script>
	import {Col, Container, Row} from "sveltestrap";
	import Camera from './Camera.svelte';

	let img_url = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/';
	let header1 = img_url + 'M4KB_Gemeinsam_digital_300dpi.png';
	let header2 = img_url + 'logo_md40_kompetenzzentrum_berlin_RGB.png';
	let footer1 = img_url + 'MittelstandDigital_Single_CMYK.jpg';
	let footer2 = img_url + 'BMWi_Fz_2017_Web_de.gif';


</script>


<Container>
	<!--
	<Row>
		<Col xs="2">
			<div class='header'>
				<img src={header1} alt="logo-gd">
			</div>
		</Col>
		<Col xs="8">
		</Col>
		<Col xs="2">
			<div class='header'>
				<img src={header2} alt="logo-mittelstand4.0">
			</div>
		</Col>
	</Row>
	-->

	<Row>
		<Col xs="2"></Col>
		<Col xs="8">
			<h2>Neural Style Transfer</h2>
			<p class="description">
				Der Demonstrator basiert auf der Methode des Neural Style Transfers. Im Hintergrund läuft ein sogenanntes Convolutional Neural Net (CNN) – ein maschineller Lernalgorithmus.
				Das CNN extrahiert Inhaltsstatistiken aus dem eingegebenen Bild und den „Stil“ aus dem Gemälde.
				Dann generiert ein weiteres Neuronales Netzwerk die zu sehenden "Style Transfer" Bilder, welche optimal das Bild mit dem Stil verbinden.
				So kann ein:e Anwender:in sich z.B. im Stil eines bekannten Kunstwerks zeichnen lassen.
				Der Algorithmus ist in der Lage, beliebige Inhaltsbilder mit beliebigen Stilen (hier 12 vorausgewählt) zu verbinden.
			</p>
		</Col>
		<Col xs="2"></Col>
	</Row>

<Row>

	<Col xs="2"></Col>
	<Col xs="8">
<Camera /></Col>
	<Col xs="2"></Col>
</Row>



	<Row>
		<hr/>

	</Row>
	<Row>
		<Col xs="2">
			<div class='footer'>
				<img src={footer1} alt='logo-mittelstand-digital'>
			</div>
		</Col>
		<Col xs="8">
		</Col>
		<Col xs="2">
			<div class='footer'>
				<img src={footer2} alt='logo-bmwi'>
			</div>
		</Col>
	</Row>

</Container>

<style>
	.description {
		margin-bottom: 100px;
		margin-top: 60px;
	}
	.header {
		margin-top: 50px;
		margin-bottom: 50px;
	}
	.footer img {
		width: 100%;
		/* height: 100%; */
	}
	.header img {
		width: 100%;
	}
	h2, p {
		text-align: center;
	}
	.footer {
		margin-top: 50px;
		margin-bottom: 50px;

	}
	hr {
		margin-top: 90px;
	}
</style>